export default __webpack_public_path__ + "ef628326ee4d012b5bc3f71bc31fc856.jpg";